import { render, staticRenderFns } from "./game-history.vue?vue&type=template&id=08381268&scoped=true"
import script from "./game-history.vue?vue&type=script&lang=js"
export * from "./game-history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08381268",
  null
  
)

export default component.exports